import React from 'react'
import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import GetIcon from "../../../../utils/Icon";
import printerimg from "../../../../assets/print.png"
import Button from "../../../../Core/Button/Button";
import FormLayoutTwo from "../../../../Core/Layout/FormLayoutTwo";
import { useGetItemTaxTemplateByNameQuery, useUpdateItemTaxTemplateMutation } from '../../../../store/api/itemtaxapi';
import ApiResponseBox from '../../../../Components/ApiResponseBox';
import Tab1 from "./Tab1";
import Tab2 from './Tab2';
import Attachment from '../../../../utils/Attachment';
import { usePageState } from "../../../../Hook/usePageState";
import { isStateChanged } from "../../../../utils/stateComparator";
function Itemtax() {
    const location = useLocation()
    const taxId = location?.state.taxId
    const navigate = useNavigate()
    const [error, setError] = useState('');
    const [ptype, setptype] = useState("Error")
    const [itemtax, setItemtax] = useState('')
    const [showError, setShowError] = useState(false);
    const [status, setStatus] = useState(false)


    const pageStateDefault = {
              tab: 1,
              title:'',
              company:'',
              gst_treatment:'',
              gst_rate:'',
              selectedTaxAccounts:[{  tax_type: "",
        tax_rate: ""}],
          
            };
          
            const [pageState, setPageState] = usePageState(`Edit Item Tax Template - ${taxId}`, pageStateDefault);
          
          
            const { tab,title,company,gst_treatment,gst_rate,selectedTaxAccounts} = pageState;

    const [selectedtax, setSelectedtax] = useState([])
    const { data: itemdata } = useGetItemTaxTemplateByNameQuery(taxId)
    const [updateItemTaxTemplate] = useUpdateItemTaxTemplateMutation();
    const handleChange = (e) => {
        const { name, value } = e.target;
        setPageState((prev) => ({
            ...prev,
            [name]: name === 'gst_rate' ? Number(value) : value,
        }));
    };


    useEffect(() => {
        if (!isStateChanged(pageState, pageStateDefault)) {
        if (itemdata?.data) {
            const { name, company, gst_treatment, gst_rate, title,taxes } = itemdata.data;
            setItemtax(itemdata.data);
            setPageState({
                title: title || name,
                company: company || "",
                gst_treatment: gst_treatment || "",
                gst_rate: gst_rate,
                selectedTaxAccounts:taxes
            });
        }
    }
    }, [itemdata]);

   const handleSubmit = async () => {
  const payload = {
    title: pageState.title,
    company: pageState.company,
    gst_treatment: pageState.gst_treatment,
    gst_rate: Number(pageState.gst_rate),
    taxes: (selectedTaxAccounts || []).map(tax => ({
      ...tax,
      tax_rate: Number(tax.tax_rate) || 0, // ✅ ensure numeric
    })),
  };

  try {
    const response = await updateItemTaxTemplate({ name: taxId, data: payload }).unwrap();
    console.log("✅ Mutation response:", response);
    setError("Item Tax Template updated successfully!");
    setptype("Success");
    setShowError(true);
    setStatus(true);
    setTimeout(() => {
      navigate("/master/itemtax/item-tax-list");
    }, 3000);
  } catch (error) {
    console.error("❌ Error updating Item Tax Template:", error);
    let message = "An unexpected error occurred.";
    try {
      if (error?.data?._server_messages) {
        const parsedMessages = JSON.parse(error.data._server_messages);
        if (parsedMessages?.length > 0) {
          const firstMessageObj = JSON.parse(parsedMessages[0]);
          message = firstMessageObj?.message || message;
        }
      } else if (error?.data?.message) {
        message = error.data.message;
      } else if (error?.error) {
        message = error.error;
      }
    } catch (e) {
      console.warn("Error parsing server message:", e);
    }
    setError(message);
    setptype("Error");
    setShowError(true);
  }
};

    return (
        <>
            <FormLayoutTwo
                title="Edit Item Tax Template"
                breadcrumbs={[
                    { label: "Item Tax Template" },
                    { label: "Item Tax Template List ", url: "/master/itemtax/item-tax-list" }
                ]}
                status={'hide'}
                actionButtons={
                    <>
                        <Button
                            className="custom-btn-00989"
                            iconName="LuFilePlus2"
                            style={{ gap: '2px', height: '28px' }}
                            onClick={handleSubmit}
                            iconSize={12}
                        >Update
                        </Button>
                        <Button
                            to="/brand/create-brand"
                            className="px-2"
                            imgSrc={printerimg}
                            imgStyle={{ width: '21px' }}
                        />
                    </>
                }
            >
                <div className="" style={{ width: "100%", backgroundColor: "#fff", flexGrow: '1' }}>
                    <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
                        <div className="d-flex justify-content-between align-items-end ">
                            <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
                                <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner" >
                                    <a className={tab == 1 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { setPageState({ ...pageState, tab: 1 }) }} href="#">
                                        General Details{tab == 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                    </a>
                                </li>
                            </ul>
                            <Attachment doctype="Item Tax Template"  docname={taxId}  /> 
                        </div>
                    </div>


                      <div className=" " style={{ background: '' }}>
                    <div className="row">
                      <div className="col-12">
                        <div >

                            <Tab1  
                                      taxId={taxId}               
                                                     pageState={pageState}
                                            setPageState={setPageState}
                          handleChange={(f, v) => setPageState({ ...pageState, [f]: v })}
                            onInputChange={(f, v) => setPageState({ ...pageState, [f]: v })}
                                              selectedTaxAccounts={{
                            value: pageState.selectedTaxAccounts || [],
                            setValue: (val) =>
                              setPageState({
                                ...pageState,
                                selectedTaxAccounts: val,
                              }),
                          }}  />

                         
                        </div>
                      </div>
                    </div>
                  </div>        

                   
                </div>
                <ApiResponseBox
                    poptype={ptype}
                    show={showError}
                    errorMessage={error}
                    onClose={() => setShowError(false)}
                />
            </FormLayoutTwo>
        </>
    )
}

export default Itemtax
